import requests from './httpService';

const StudentChargeMasterService = {
  list() {
    return requests.get('/studentchargemaster/list');
  },
  upsert(body) {
    return requests.post('/studentchargemaster/upsert', body);
  },
  delete(id) {
    return requests.delete(`/studentchargemaster/${id}`);
  },
};

export default StudentChargeMasterService;

